import { APP_TOKEN_KEY, CART_SOCKET_HOST, CART_SOCKET_PATH} from "../../lib/env";
import React from "react";
import { io, Socket } from "socket.io-client";


export type TSocketsContext = {
  socket: React.MutableRefObject<Socket | undefined>
}

export const SocketsContext = React.createContext<TSocketsContext | null>(null)


export default function SocketsProvider(props: {
  children: React.ReactNode
}) {

  const socket = React.useRef<Socket>()

  React.useEffect(() => {
    socket.current = io(`${CART_SOCKET_HOST}/semantic-search`, {
      path: CART_SOCKET_PATH,
      autoConnect: true,
      auth: {
        token: `Bearer ${localStorage.getItem(APP_TOKEN_KEY)}`
      }
    })

    return () => {
      socket.current?.disconnect();
      socket.current = undefined
    }
  }, [])


  return (
    <SocketsContext.Provider value={{socket}}>
      { props.children }
    </SocketsContext.Provider>
  );

}
